var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conversation-profile-wrapper"},[(_vm.currentConversation.type === _vm.TIM.TYPES.CONV_C2C)?_c('user-profile',{attrs:{"userProfile":_vm.currentConversation.userProfile}}):(_vm.currentConversation.type === _vm.TIM.TYPES.CONV_GROUP)?_c('group-profile',{attrs:{"groupProfile":_vm.currentConversation.groupProfile}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }